import React from "react";

export default function RecognitionSection() {
  return (
    <section className="w-full bg-[#0B0F19] py-24">
      <div className="mx-auto max-w-6xl px-4">
        {/* Header */}
        <div className="mb-14 max-w-3xl">
          <h2 className="text-3xl font-bold text-white">
            Recognition <span className="text-blue-600">That Empowers</span>
          </h2>
          <p className="mt-2 text-gray-500">
            At Million2Trillion, every role matters. Every contribution counts.
            Your performance is seen. Your voice is valued.
          </p>
        </div>

        {/* Content Layout */}
        <div className="grid items-center gap-16 md:grid-cols-2">
          {/* LEFT IMAGE */}
          <div className="relative overflow-hidden rounded-3xl border border-white/10 shadow-[0_30px_80px_rgba(0,0,0,0.35)]">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/awards%2Fm2t-awards1.jpg?alt=media&token=be2e8297-0f87-40e9-aaa1-9346dec6a48b"
              alt="M2T Recognition Awards"
              className="w-full rounded-3xl border-2 border-white object-cover"
            />
          </div>

          {/* RIGHT STORY */}
          <div className="space-y-6">
            <h3 className="text-2xl font-semibold leading-snug text-white">
              Million2Trillion Recognizes Every Professional.
            </h3>

            <p className="leading-relaxed text-gray-400">
              M2T is not just a marketplace — it is a performance-driven
              professional ecosystem. Every insight you share, every discussion
              you contribute to, every product you launch, every strategy you
              publish — builds your reputation.
            </p>

            <p className="leading-relaxed text-gray-400">
              Your reach matters. Your engagement matters. Your consistency
              matters.
            </p>

            <p className="font-medium text-gray-300">
              Earn your badge. Build your authority. Rise from Member to
              Ambassador.
            </p>

            <div className="pt-4">
              <p className="font-semibold text-blue-500">
                ⭐ Every performance is valued. 🏅 Every role is empowered. 👑
                Your voice becomes your power.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
